export default __webpack_public_path__ + "static/media/misc-drawerA-1920w.0b3ad0bb.avif";